module.exports = __webpack_public_path__ + "img/gntech_gallery6.9f7f6427.jpg";